import { connect } from "react-redux";

import Modal from "@components/Modal";
import LoginForm from "@containers/Account/LoginForm";
import { addModal } from "@store/app/actions";

const LoginModal = ({
  addModal,
  location,
  modalId,
  registerModalId,
  resetPassModalId,
  redirect,
}) => (
  <Modal id={modalId} header="Intra in cont" size="small">
    <LoginForm
      recoverPassInModal={true}
      location={location}
      registerModalId={registerModalId}
      resetPassModalId={resetPassModalId}
      redirect={redirect}
    />

    <div className="text-center">
      <button
        type="button"
        onClick={() => addModal(registerModalId)}
        className="text-sm text-red-brand hover:text-bleu-hover underline"
      >
        Creeaza cont nou
      </button>
    </div>
  </Modal>
);

export default connect(null, {
  addModal,
})(LoginModal);
